export default __webpack_public_path__ + "static/media/36I-102785_-15904_0.eaffc44c.jpg";